import { map, compact, find, some, filter, isArray } from "lodash";
import conventionManager from "./conventionManager";
import { privateDico } from "@/assets/dico/privateDico";

class MenuManager {
    /**
     *
     * @param sections
     */
    getItems(convention) {
        const { sections, sectionsDraft } = convention;
        const themes = privateDico.convention.themes;
        return map(themes, (theme, sectionName) => {
            const section = find(sections, s => s.key === sectionName);
            if (section) {
                const [, titleContent] = this.splitTitleAndKey(section.title);
                const item = {
                    key: section.key,
                    type: section.type,
                    title: titleContent,
                    children: [],
                    class: "full",
                    legend: "",
                    level: 1,
                };
                if (isArray(section.children) && section.children.length > 0) {
                    return { ...item, children: this._getItems(section.children, item) };
                }
                return item;
            } else {
                const isDraft = some(sectionsDraft || [], name => name === sectionName);
                const isParentEnveloppe = conventionManager.isParentEnveloppe(convention);
                const newItem = {
                    key: theme._uid,
                    title: theme,
                    level: 1,
                    children: [],
                    class: "empty",
                };
                if (isDraft) {
                    return { ...newItem, legend: "Prochainement en ligne" };
                }
                if (isParentEnveloppe) {
                    return { ...newItem, legend: "Pas de dispositions communes" };
                }
                return { ...newItem, legend: "Pas de dispositions" };
            }
        });
    }
    /**
     *
     * @param sections
     * @param parentItem
     * @param level
     */
    _getItems(sections, parentItem) {
        return compact(
            filter(sections, section => section.type !== "note-di").map(section => {
                const [, titleContent] = this.splitTitleAndKey(section.title);
                const title = document.getElementById(section.key);
                const level = parentItem ? parentItem.level + 1 : 1;
                if (title?.style.display === "none" && level > 1) {
                    return null;
                }
                const newItem = {
                    key: section.key,
                    title: titleContent,
                    level: level,
                    type: section.type,
                    children: [],
                    legend: "",
                };
                if (isArray(section.children) && section.children.length > 0 && level < 4) {
                    newItem.children = this._getItems(section.children, newItem);
                }
                return newItem;
            })
        );
    }

    splitTitleAndKey(title) {
        if (title.indexOf("|") > -1) {
            return [title.split("|")[0].trim(), title.split("|")[1].trim()];
        }
        return ["", title];
    }
}

const menuManager = new MenuManager();
export default menuManager;
